import React, { useState } from 'react';
import {
  Alert, Box, Button, Stack, TextField, Typography,
} from '@mui/material';

import axiosInstance from '../../axiosInstance';

const VIDE = { name: '', reference: '' };

/**
 * Créer un dossier d'expertise.
 *
 * Deux champs suffisent : le reste se remplit dans le dossier. L'ancien écran
 * en faisait une page entière, avec un panneau d'aide qui répétait ce que les
 * étiquettes disaient déjà.
 */
function CreateExpertise({ onCree, onAnnule }) {
  const [dossier, setDossier] = useState(VIDE);
  const [erreur, setErreur] = useState('');
  const [occupe, setOccupe] = useState(false);

  const modifier = (champ) => (e) => {
    setDossier((etat) => ({ ...etat, [champ]: e.target.value }));
    if (erreur) setErreur('');
  };

  const soumettre = async (e) => {
    e.preventDefault();
    setOccupe(true);
    setErreur('');
    try {
      const { data } = await axiosInstance.post('/expertise/', {
        ...dossier, name: dossier.name.trim(),
      });
      // Créer sans ouvrir n'a pas de sens : on enchaîne sur le dossier.
      if (onCree) onCree(data.id);
    } catch (error) {
      setErreur(error.response?.data?.name?.[0]
        || "L'expertise n'a pas pu être créée.");
      setOccupe(false);
    }
  };

  return (
    <Box component="form" onSubmit={soumettre} noValidate sx={{ pt: 1 }}>
      {erreur && <Alert severity="error" sx={{ mb: 2.5 }}>{erreur}</Alert>}

      <Stack spacing={2.5}>
        <TextField
          label="Nom de l'expertise"
          value={dossier.name}
          onChange={modifier('name')}
          autoFocus
          required
          disabled={occupe}
          helperText="Ce nom identifie le dossier dans la liste."
        />

        <TextField
          label="Référence"
          value={dossier.reference}
          onChange={modifier('reference')}
          disabled={occupe}
          helperText="Numéro de sinistre ou code interne. Facultatif."
        />

        <Typography variant="caption" color="text.secondary">
          Le dossier s'ouvrira aussitôt créé.
        </Typography>

        <Stack direction="row" spacing={1.5} justifyContent="flex-end">
          <Button onClick={onAnnule} disabled={occupe}>Annuler</Button>
          <Button type="submit" variant="contained"
                  disabled={occupe || !dossier.name.trim()}>
            {occupe ? 'Création…' : "Créer l'expertise"}
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}

export default CreateExpertise;
